import { render, staticRenderFns } from "./AppBrandWarning.vue?vue&type=template&id=8fbae41c"
import script from "./AppBrandWarning.vue?vue&type=script&lang=js"
export * from "./AppBrandWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports